import React from 'react';
var SidebarNavContext = /*#__PURE__*/React.createContext(null);
export default SidebarNavContext;